/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindOperationTreeByProductIdsQueryResponse,
  FindOperationTreeByProductIdsQueryParams,
} from "../types/FindOperationTreeByProductIds.ts"

export const findOperationTreeByProductIdsQueryKey = (
  params: FindOperationTreeByProductIdsQueryParams
) =>
  [
    { url: "/v1/operation/find-operation-tree-by-product-ids" },
    ...(params ? [params] : []),
  ] as const

export type FindOperationTreeByProductIdsQueryKey = ReturnType<
  typeof findOperationTreeByProductIdsQueryKey
>

/**
 * @summary Find operation trees by product UUIDs
 * {@link /v1/operation/find-operation-tree-by-product-ids}
 */
export async function findOperationTreeByProductIds(
  params: FindOperationTreeByProductIdsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindOperationTreeByProductIdsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/operation/find-operation-tree-by-product-ids`,
    params,
    ...requestConfig,
  })
  return res
}

export function findOperationTreeByProductIdsQueryOptions(
  params: FindOperationTreeByProductIdsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findOperationTreeByProductIdsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindOperationTreeByProductIdsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindOperationTreeByProductIdsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findOperationTreeByProductIds(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find operation trees by product UUIDs
 * {@link /v1/operation/find-operation-tree-by-product-ids}
 */
export function useFindOperationTreeByProductIds<
  TData = ResponseConfig<FindOperationTreeByProductIdsQueryResponse>,
  TQueryData = ResponseConfig<FindOperationTreeByProductIdsQueryResponse>,
  TQueryKey extends QueryKey = FindOperationTreeByProductIdsQueryKey,
>(
  params: FindOperationTreeByProductIdsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindOperationTreeByProductIdsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findOperationTreeByProductIdsQueryKey(params)

  const query = useQuery(
    {
      ...findOperationTreeByProductIdsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
